import React, { useState, useMemo } from "react";
import { Container, Header, Tabs, Badge, SpaceBetween } from "@cloudscape-design/components";
import { CustomerData, CustomerDataHistory } from "../../services";
import { TableName, TABLE_NAMES, TABLE_LABELS, LABELS } from "../../constants";
import { DataTab } from "./DataTab";

interface CustomerDataPanelProps {
  data: CustomerData;
  history: CustomerDataHistory | null;
}

export const CustomerDataPanel: React.FC<CustomerDataPanelProps> = ({ data, history }) => {
  const firstActiveTab = useMemo(() => TABLE_NAMES.find((t) => data[t] !== null) || TABLE_NAMES[0], [data]);

  const [activeTabId, setActiveTabId] = useState<string>(firstActiveTab);

  const getTabCount = (table: TableName): number => {
    const hasData = data[table] !== null;
    const historyCount = history?.[table]?.length || 0;
    return hasData ? 1 + historyCount : 0;
  };

  const tabs = TABLE_NAMES.map((table) => {
    const count = getTabCount(table);
    const hasData = data[table] !== null;

    return {
      id: table,
      label: (
        <SpaceBetween direction="horizontal" size="xs" alignItems="center">
          <span>{TABLE_LABELS[table]}</span>
          {hasData && <Badge color="green">{count}</Badge>}
        </SpaceBetween>
      ),
      content: <DataTab table={table} data={data} history={history} />,
      disabled: !hasData,
    };
  });

  return (
    <Container header={<Header variant="h2">{LABELS.CUSTOMER_DATA}</Header>}>
      <Tabs tabs={tabs} activeTabId={activeTabId} onChange={({ detail }) => setActiveTabId(detail.activeTabId)} />
    </Container>
  );
};
